let body = document.body

export default {
  hideScroll () {
    body.classList.add('body-no-scroll')
    this.topScroll = window.pageYOffset
    body.style.position = 'fixed'
    body.style.width = '100%'
    body.style.top = `-${this.topScroll}px`
  },
  showScroll () {
    body.classList.remove('body-no-scroll')
    body.style.position = ''
    body.style.width = ''
    body.style.top = ''
    window.scroll(0, this.topScroll)
  }
}